import type { FormattingStyleOverride } from "../skills/formattingStyle";

export type ExcelBrandId = "ubs";

export interface ExcelBrandDefaults {
  id: ExcelBrandId;
  label: string;
  toggleLabel: string;
  accentColorHex: string;
  formattingStyleOverride: FormattingStyleOverride;
}

// Source: AI-3416 and the reviewed DCF template attachment.
// Attachment SHA-256: F1476866F4B9B7DD9DC1AB601E5EA572A17C07A511285AE2643F3BDCCF9B553C.
const UBS_VISUAL_DEFAULTS_BLOCK = `**UBS defaults - the concrete visual fallback when no bank template is supplied.** A supplied template's theme overrides every visual value below (precedence: template > UBS defaults > skill). Use these exact visual values only in the absence of a template:
- Main title: 18pt bold black #000000 text with no fill.
- Major section headers: #8A000A fill with white #FFFFFF bold 10pt text.
- Subsection headers: #8E8D83 fill with white #FFFFFF bold 10pt text.
- Input cells: #FFFFCC fill; hardcoded input font #0000FF.
- Formula and regular cells: black #000000 text with no fill; preserve worksheet gridlines and never use solid white as a substitute for no fill.
- Total rows: #F2F2F2 fill with black #000000 bold 10pt text.
- Typography: Frutiger 45 Light with Arial if unavailable; 10pt body text.
- Restrained emphasis: UBS red #E60000.
- Classification colours: hardcoded input = blue #0000FF; formula = black #000000; cross-sheet/external link = green #00B050; FactSet / FDS pull = purple #7030A0. Treat live FactSet pulls as their own source-linked class, distinct from ordinary cross-sheet links.
- Charts: for ordinary range-based Excel charts created from workbook ranges, use accent colours in this order: #8A000A, #8E8D83, #B98E2C, #5A5D5C, #BD000C, #946F29. Do not recolour \`native_chart\` / Chart Creator template workbooks.`;

export const UBS_EXCEL_DEFAULTS: ExcelBrandDefaults = {
  id: "ubs",
  label: "UBS",
  toggleLabel: "UBS defaults",
  accentColorHex: "#E60000",
  formattingStyleOverride: {
    label: "UBS",
    visualDefaultsBlock: UBS_VISUAL_DEFAULTS_BLOCK,
  },
};

export function getExcelBrandDefaults(
  value: string | null | undefined,
): ExcelBrandDefaults | undefined {
  return value === UBS_EXCEL_DEFAULTS.id ? UBS_EXCEL_DEFAULTS : undefined;
}
